import React, { useState, useRef, useEffect, useCallback } from "react";
import EmojiPicker from "emoji-picker-react";
import { db } from "../../Hooks/FirebaseConfig";
import {
  addDoc,
  collection,
  query,
  where,
  onSnapshot,
  orderBy,
  serverTimestamp,
  doc,
  getDoc,
  setDoc,
} from "firebase/firestore";
import ChatSidebar from "./ChatSidebar";
import Cookies from "js-cookie";
import { sendMessageBack } from "../../apis/api/ChatApi";
import { useDispatch,useSelector } from "react-redux";

const Chat = () => {
  const [showPicker, setShowPicker] = useState(false);
  const [inputValue, setInputValue] = useState("");
  const inputRef = useRef(null);
  const pickerRef = useRef(null);
  const [messages, setMessages] = useState([]);
  const [receiverData, setReceiverData] = useState(null); 
  const senderId = Number(Cookies.get("userID"));
  const [sidebarVersion, setSidebarVersion] = useState(0);
  const user = JSON.parse(Cookies.get("user"));
  
  const receiverId = receiverData?.id ? Number(receiverData.id) : null;
const dispatch = useDispatch();
  const listenToMessages = (senderId, receiverId, callback) => {
    const messagesRef = collection(db, "messages");
    const q = query(
      messagesRef,
      where("participants", "in", [
        [senderId, receiverId],
        [receiverId, senderId],
      ]),
      orderBy("createdAt", "asc")
    );

    const unsubscribe = onSnapshot(q, (querySnapshot) => {
      const messages = [];
      querySnapshot.forEach((doc) => {
        messages.push({ id: doc.id, ...doc.data() });
      });

      callback(messages);
    });

    return unsubscribe;
  };

  useEffect(() => {
    if (!receiverId) return;
    const unsubscribe = listenToMessages(senderId, receiverId, setMessages);
    return () => unsubscribe();
  }, [senderId, receiverId]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        pickerRef.current &&
        !pickerRef.current.contains(event.target) &&
        !inputRef.current.contains(event.target)
      ) {
        setShowPicker(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const onEmojiClick = (emojiData) => {
    setInputValue((prev) => prev + emojiData.emoji);
    setShowPicker(false);
  };

  const addUserIfNotExists = async (Id, profileData) => {
    let userId = Id;
    if (!Id || typeof Id !== "string") {
      userId = userId.toString();
    }

    try {
      const userRef = doc(db, "users", userId);
      const docSnap = await getDoc(userRef);

      if (!docSnap.exists()) {
        await setDoc(userRef, profileData);
        console.log("User added to users collection.");
      } else {
        console.log("User already exists.");
      }
    } catch (error) {
      console.error("Error adding user:", error);
    }
  };

  const sendMessage = async () => {
    if (inputValue.trim() && receiverId) {
      await addDoc(collection(db, "messages"), {
        text: inputValue,
        sender_Id: senderId,
        receiver_Id: receiverId,
        participants: [senderId, receiverId],
        createdAt: serverTimestamp(),
      });

      await addUserIfNotExists(receiverId, {
        receiver_Id: receiverData.id,
        full_name: receiverData.full_name,
        member_logo: receiverData.member_logo,
        company_name: receiverData.company_name,
      });

      await addUserIfNotExists(senderId, {
        receiver_Id: senderId,
        full_name: user.fullname,
        member_logo: user.member_logo,
        company_name: user.company_name,
      });
      await dispatch(sendMessageBack({
        full_name: user.fullname,
        senderId: senderId,
        receiverId: receiverId,
        message: inputValue,
      }))
      setSidebarVersion((prev) => prev + 1);
      setInputValue("");
    }
  };

  const handleDataFromSidebar = useCallback((data) => {
    console.log(data, "callback");
    setReceiverData(data);
  }, []);

  return (
    <>
      <div class="">
        <div class="">
          <div class="page-content">
            <div class="chat-wrapper">
              <ChatSidebar
                version={sidebarVersion}
                sendData={handleDataFromSidebar}
              />
              <div class="chat-header d-flex align-items-center">
                <div class="chat-toggle-btn">
                  <i class="bx bx-menu-alt-left"></i>
                </div>
                <div>
                  <h4 class="mb-1 font-weight-bold">
                    {receiverData ? receiverData.full_name : "Welcome"}
                  </h4>
                  <div class="list-inline d-sm-flex mb-0 d-none">
                    {receiverData && (
                      <a
                        href="javascript:;"
                        class="list-inline-item d-flex align-items-center text-secondary"
                      >
                        <small class="bx bxs-circle me-1 chart-online"></small>
                        {receiverData.company_name}
                      </a>
                    )}
                  </div>
                </div>
              </div>

              <div class="chat-content chat-messages-wrapper">
                {!receiverData ? (
                  <div className="chat-welcome-screen d-flex flex-column justify-content-center align-items-center text-center p-4">
                    <div className="welcome-content animate__animated animate__fadeInUp">
                      <i
                        className="bx bx-chat bx-tada mb-4"
                        style={{ fontSize: "120px", color: "#007bff" }}
                      ></i>

                      <h3 className="mb-3 fw-bold text-primary">
                        Welcome to the Chat
                      </h3>
                      <p className="text-muted">
                        Start a conversation by selecting a user from the
                        sidebar.
                      </p>
                    </div>
                  </div>
                ) : (
                  messages?.map((msg) =>
                    msg.sender_Id === senderId ? (
                      <div
                        className="chat-content-rightside mt-6 leftsidep-5"
                        key={msg.id}
                      >
                        <div className="d-flex ms-auto mt-5 pt-4">
                          <div className="flex-grow-1 me-2">
                            <p className="mb-0 chat-time text-end">{}</p>
                            <p className="chat-right-msg">{msg.text}</p>
                          </div>
                        </div>
                      </div>
                    ) : (
                      <div className="chat-content-leftside mt-15" key={msg.id}>
                        <div className="d-flex">
                          <img
                            src={
                              receiverData.member_logo ||  `${process.env.PUBLIC_URL}/gray-avatar-icon-vector-illustration_276184-163.avif`
                            }
                            width="48"
                            height="48"
                            className="rounded-circle"
                            onError={(e) => {
                              e.target.onerror = null;
                              e.target.src =
                                "/gray-avatar-icon-vector-illustration_276184-163.avif";
                            }}
                            alt=""
                          />
                          <div className="flex-grow-1 ms-2">
                            <p className="mb-0 chat-time">{}</p>
                            <p className="chat-left-msg">{msg.text}</p>
                          </div>
                        </div>
                      </div>
                    )
                  )
                )}
              </div>

              <div class="chat-footer d-flex align-items-center">
                <div class="flex-grow-1 pe-2">
                  <div class="input-group">
                    <span
                      className="input-group-text"
                      style={{ cursor: "pointer" }}
                      onClick={() => setShowPicker((val) => !val)}
                    >
                      <i className="bx bx-smile"></i>
                    </span>
                    {showPicker && (
                      <div
                        ref={pickerRef}
                        className="position-absolute"
                        style={{ top: "-300px", zIndex: 999 }}
                      >
                        <EmojiPicker onEmojiClick={onEmojiClick} />
                      </div>
                    )}
                    <input
                      ref={inputRef}
                      type="text"
                      className="form-control"
                      placeholder="Type a message..."
                      value={inputValue}
                      onChange={(e) => setInputValue(e.target.value)}
                      disabled={!receiverData}
                    />
                  </div>
                </div>
                <div class="chat-footer-menu">
                  <button
                    className="btn btn-outline-secondary btn-sm"
                    onClick={sendMessage}
                    disabled={!receiverData}
                  >
                    <i className="bx bx-send"></i>
                  </button>
                </div>
              </div>

              <div class="overlay chat-toggle-btn-mobile"></div>
            </div>
          </div>
        </div>

        <div class="overlay toggle-icon"></div>

        <a href="javaScript:;" class="back-to-top">
          <i class="bx bxs-up-arrow-alt"></i>
        </a>

        <footer class="page-footer">
          <p class="mb-0">Copyright © 2021. All right reserved.</p>
        </footer>
      </div>
    </>
  );
};

export default Chat;
